import { createLocalStorage } from "/@/utils/cache";
import { TOKEN_KEY } from "/@/enums/cacheEnum";
import { authApi, getUserOnlineStatusApi } from "/@/api/user";
import { useUserStoreWithOut } from "/@/store/modules/user";


export const initAuth = async (): Promise<void>=>{
 if (window.location.hash === "#/login") return;
 const { content, code } = await authApi();
 if(code == 200) {
    const userStore = useUserStoreWithOut();
    userStore.setUserInfo(content)
    userStore.setRules(content?.ruleSet);
 }
}

export const initOnline = async (): Promise<void>=>{
let ls = createLocalStorage();
 if (!ls.get(TOKEN_KEY) || window.location.hash === "#/login") return;
 const { content, code } = await getUserOnlineStatusApi();
 if(code == 200) {
    const userStore = useUserStoreWithOut();
    userStore.setOnlineInfo(content)
 }
}
export default {  initAuth, initOnline};
